import {
  Category,
  BaseSavedSearch,
  SavedSearchInput,
  NotificationChannels,
} from "../model/model";
import { SavedSearchClientFactory } from "../clients/SavedSearchClientFactory";
import { SavedSearchClient } from "../model/SavedSearchClient";
import { SavedSearchService } from "../model/SavedSearchService";
import { trackSavedSearchSettings } from "../Tracking";

export class DefaultSavedSearchService implements SavedSearchService {
  private client: SavedSearchClient;

  constructor(category: Category) {
    this.client = SavedSearchClientFactory.getClient(category);
  }

  getAllSavedSearches(): Promise<BaseSavedSearch[]> {
    return this.client.getAll();
  }

  async getSavedSearch(id: number): Promise<BaseSavedSearch> {
    return this.client.get(id);
  }

  async updateSavedSearchName(
    search: BaseSavedSearch,
    name: string
  ): Promise<BaseSavedSearch> {
    const updatedSavedSearch = { ...search, name: name.trim() };
    await this.client.update(updatedSavedSearch);
    return updatedSavedSearch;
  }

  async updateSavedSearchChannels(
    search: BaseSavedSearch,
    notifications: NotificationChannels
  ): Promise<BaseSavedSearch> {
    const updatedSavedSearch = { ...search, notifications };

    await this.client.update(updatedSavedSearch);
    trackSavedSearchSettings.update(notifications);

    return updatedSavedSearch;
  }

  async deleteSavedSearch(id: number): Promise<void> {
    await this.client.delete(id);
    trackSavedSearchSettings.delete();
  }

  async createSavedSearch(
    name: string,
    notifications: NotificationChannels,
    metadata?: SavedSearchInput
  ): Promise<BaseSavedSearch> {
    const trimmedName = name.trim();
    const id = await this.client.create(trimmedName, notifications, metadata);
    return { id, name: trimmedName, notifications };
  }
}
